export enum MCarouselControlsType {
  Dots = 'dots',
  Numbers = 'numbers',
}

export interface MCarouselControlsProps {
  type?: MCarouselControlsType;
  imageOverlay?: boolean;
  totalSlides?: number;
  currentSlide?: number;
  onNext?: () => void;
  onPrev?: () => void;
  className?: string;
  arrows?: boolean;
  /**
   * Keeps boundary arrows enabled for parent carousels that wrap from last to first.
   */
  loop?: boolean;
}
